// ============================================================
// SEO metadata — per page × per language
// Used by <SEO pageKey="..." /> component (react-helmet-async)
// ============================================================

export const SITE = {
  name: "Dar Hasna Collection",
  baseUrl: "https://darhasnacollection.com",
  defaultImage: "https://darhasnacollection.com/villas/hasna/IMG_0771.jpeg",
};

export const seoData = {
  fr: {
    home: {
      title: "Dar Hasna Collection — Villas privées Palmeraie Marrakech",
      description:
        "Deux villas privatives d'exception au cœur de la Palmeraie de Marrakech. Villa Ismaël (8 pax) et Villa Hasna, maison d'hôtes (3 suites, 6 pax). Piscine privée, jardin 1700 m². Réservation directe.",
      keywords:
        "villa privée Marrakech, location villa Palmeraie, maison d'hôtes Marrakech, Dar Hasna, villa piscine Marrakech, séjour luxe Marrakech",
    },
    ismael: {
      title: "Villa Ismaël — Villa privée avec piscine 28m · Palmeraie Marrakech",
      description:
        "Louez Villa Ismaël en privatisation exclusive : 4 suites, 8 personnes, piscine chauffable 28 m, jardin 1700 m² sans vis-à-vis. Palmeraie Marrakech, à 3 km du centre-ville.",
      keywords:
        "Villa Ismaël, location villa privée Marrakech, villa piscine Palmeraie, privatisation villa Marrakech, villa 8 personnes Marrakech",
    },
    hasna: {
      title: "Villa Hasna — Maison d'hôtes & privatisation · Palmeraie Marrakech",
      description:
        "Maison d'hôtes familiale à Marrakech Palmeraie. Réservation à la suite (dès 947 MAD/nuit) ou privatisation complète (6 personnes). Piscine 25 m chauffable, jardin 1700 m².",
      keywords:
        "Villa Hasna, maison d'hôtes Marrakech, guesthouse Palmeraie, suite Marrakech piscine, séjour famille Marrakech",
    },
    services: {
      title: "Services & Tarifs — Chef privé, spa, transferts · Dar Hasna Marrakech",
      description:
        "Chef privé, femme de maison, transferts aéroport, massages, service nounou. Tarifs détaillés des services Dar Hasna Collection à la Palmeraie de Marrakech.",
      keywords:
        "chef privé Marrakech, spa villa Marrakech, transfert aéroport Marrakech, nounou Marrakech, services villa luxe Marrakech",
    },
    seniors: {
      title: "Séjours Sérénité Seniors — Villa Hasna Palmeraie Marrakech",
      description:
        "Formules d'une semaine à un mois pour couples seniors. Suite indépendante 50 m², piscine chauffée, chauffeur, pension complète. Villa Hasna, Palmeraie Marrakech.",
      keywords:
        "séjour senior Marrakech, résidence seniors Marrakech, retraite Marrakech, villa senior piscine chauffée, hivernage Marrakech",
    },
    family: {
      title: "Séjour Famille tout compris — Villa Hasna Marrakech",
      description:
        "3 formules famille à Villa Hasna Marrakech : villa privatisée (3 suites), 2 nounous, femme de maison. Dès 3 626 € la semaine pour 2 adultes + 4 enfants.",
      keywords:
        "séjour famille Marrakech, villa famille Marrakech, vacances famille Palmeraie, villa nounou Marrakech, location famille Marrakech",
    },
    events: {
      title: "Événements privés — Mariages, anniversaires · Palmeraie Marrakech",
      description:
        "Privatisation à la journée ou avec hébergement. Mariages intimes, anniversaires, séminaires résidentiels, retraites privées dans nos deux villas à Marrakech.",
      keywords:
        "mariage Marrakech, événement privé Marrakech, séminaire villa Marrakech, anniversaire villa Marrakech, retraite Palmeraie",
    },
    contact: {
      title: "Contact & Réservation directe — Dar Hasna Collection Marrakech",
      description:
        "Réservez directement votre séjour à Villa Ismaël ou Villa Hasna. WhatsApp +212 7 18 11 54 19 · Sidi Yahya La Palmeraie, Marrakech. Réponse sous 24h.",
      keywords:
        "réservation villa Marrakech, contact Dar Hasna, réserver villa Palmeraie, location directe villa Marrakech",
    },
  },
  en: {
    home: {
      title: "Dar Hasna Collection — Private Villas Palmeraie Marrakech",
      description:
        "Two exceptional private villas in the heart of Marrakech's Palmeraie. Villa Ismaël (8 guests) and Villa Hasna guesthouse (3 suites, 6 guests). Private pool, 1,700 sqm garden. Direct booking.",
      keywords:
        "private villa Marrakech, Palmeraie villa rental, Marrakech guesthouse, Dar Hasna, villa with pool Marrakech, luxury stay Marrakech",
    },
    ismael: {
      title: "Villa Ismaël — Private Villa with 28m Pool · Palmeraie Marrakech",
      description:
        "Rent Villa Ismaël exclusively: 4 suites, 8 guests, 28 m heatable private pool, 1,700 sqm garden with no overlook. Palmeraie Marrakech, 3 km from downtown.",
      keywords:
        "Villa Ismaël, private villa rental Marrakech, Palmeraie villa pool, Marrakech villa 8 guests, luxury villa Marrakech",
    },
    hasna: {
      title: "Villa Hasna — Guesthouse & Full Privatization · Palmeraie Marrakech",
      description:
        "Family guesthouse in Marrakech Palmeraie. Book per suite (from 947 MAD/night) or fully privatize (6 guests). 25 m heatable pool, 1,700 sqm garden.",
      keywords:
        "Villa Hasna, Marrakech guesthouse, Palmeraie suite, Marrakech family villa, boutique stay Marrakech",
    },
    services: {
      title: "Services & Rates — Private chef, spa, transfers · Dar Hasna Marrakech",
      description:
        "Private chef, housekeeper, airport transfers, massages, nanny service. Detailed rates of Dar Hasna Collection services in Marrakech Palmeraie.",
      keywords:
        "private chef Marrakech, spa villa Marrakech, airport transfer Marrakech, nanny Marrakech, luxury villa services Marrakech",
    },
    seniors: {
      title: "Serenity Stays for Seniors — Villa Hasna Marrakech",
      description:
        "One-week to one-month packages for senior couples. 50 sqm private suite, heated pool, driver, full board. Villa Hasna, Palmeraie Marrakech.",
      keywords:
        "senior stay Marrakech, seniors residence Marrakech, retirement Marrakech, heated pool villa senior, winter escape Marrakech",
    },
    family: {
      title: "All-Inclusive Family Stay — Villa Hasna Marrakech",
      description:
        "3 family packages at Villa Hasna Marrakech: fully privatized villa (3 suites), 2 nannies, housekeeper. From €3,626 per week for 2 adults + 4 children.",
      keywords:
        "family stay Marrakech, family villa Marrakech, Palmeraie family holiday, nanny villa Marrakech, family rental Marrakech",
    },
    events: {
      title: "Private Events — Weddings, Birthdays · Palmeraie Marrakech",
      description:
        "Day privatization or with accommodation. Intimate weddings, birthdays, residential seminars, private retreats in our two Marrakech villas.",
      keywords:
        "Marrakech wedding, private event Marrakech, villa seminar Marrakech, birthday villa Marrakech, Palmeraie retreat",
    },
    contact: {
      title: "Contact & Direct Booking — Dar Hasna Collection Marrakech",
      description:
        "Book directly your stay at Villa Ismaël or Villa Hasna. WhatsApp +212 7 18 11 54 19 · Sidi Yahya La Palmeraie, Marrakech. Reply within 24 hours.",
      keywords:
        "book Marrakech villa, contact Dar Hasna, book Palmeraie villa, direct booking Marrakech villa",
    },
  },
  ar: {
    home: {
      title: "دار حسناء كولكشن — فيلات خاصة النخيل مراكش",
      description:
        "فيلتان خاصتان استثنائيتان في قلب نخيل مراكش. فيلا إسماعيل (8 أشخاص) وفيلا حسناء بيت الضيافة (3 أجنحة، 6 أشخاص). مسبح خاص، حديقة 1700 م². حجز مباشر.",
      keywords:
        "فيلا خاصة مراكش، إيجار فيلا النخيل، بيت ضيافة مراكش، دار حسناء، فيلا مسبح مراكش، إقامة فاخرة مراكش",
    },
    ismael: {
      title: "فيلا إسماعيل — فيلا خاصة مسبح 28م · النخيل مراكش",
      description:
        "استأجر فيلا إسماعيل حصريًا: 4 أجنحة، 8 أشخاص، مسبح 28 م قابل للتدفئة، حديقة 1700 م² بدون إطلالة الجيران. النخيل مراكش، على بعد 3 كم من وسط المدينة.",
      keywords:
        "فيلا إسماعيل، إيجار فيلا خاصة مراكش، فيلا النخيل مسبح، فيلا 8 أشخاص مراكش",
    },
    hasna: {
      title: "فيلا حسناء — بيت ضيافة وخصخصة كاملة · النخيل مراكش",
      description:
        "بيت ضيافة عائلي في نخيل مراكش. حجز بالجناح (ابتداء من 947 درهم/ليلة) أو خصخصة كاملة (6 أشخاص). مسبح 25 م قابل للتدفئة، حديقة 1700 م².",
      keywords:
        "فيلا حسناء، بيت ضيافة مراكش، جناح النخيل، فيلا عائلية مراكش، إقامة بوتيك مراكش",
    },
    services: {
      title: "الخدمات والأسعار — طاهي خاص، سبا، تنقلات · دار حسناء مراكش",
      description:
        "طاهي خاص، مدبرة منزل، نقل من المطار، تدليك، مربية أطفال. أسعار مفصلة لخدمات دار حسناء كولكشن في نخيل مراكش.",
      keywords:
        "طاهي خاص مراكش، سبا فيلا مراكش، نقل مطار مراكش، مربية مراكش، خدمات فيلا فاخرة مراكش",
    },
    seniors: {
      title: "إقامات السكينة لكبار السن — فيلا حسناء مراكش",
      description:
        "صيغ من أسبوع إلى شهر لأزواج كبار السن. جناح مستقل 50 م²، مسبح مدفأ، سائق، إقامة كاملة. فيلا حسناء، النخيل مراكش.",
      keywords:
        "إقامة كبار السن مراكش، سكن كبار السن مراكش، تقاعد مراكش، فيلا مسبح مدفأ",
    },
    family: {
      title: "إقامة عائلية شاملة — فيلا حسناء مراكش",
      description:
        "3 صيغ عائلية في فيلا حسناء مراكش: فيلا مخصصة بالكامل (3 أجنحة)، مربيتان، مدبرة منزل. ابتداء من 3626 يورو أسبوعيًا لبالغين + 4 أطفال.",
      keywords:
        "إقامة عائلية مراكش، فيلا عائلة مراكش، عطلة عائلية النخيل، فيلا مربية مراكش",
    },
    events: {
      title: "المناسبات الخاصة — أعراس، أعياد ميلاد · النخيل مراكش",
      description:
        "خصخصة يومية أو مع الإقامة. أعراس حميمة، أعياد ميلاد، ندوات سكنية، خلوات خاصة في فيلاتنا بمراكش.",
      keywords:
        "زفاف مراكش، مناسبة خاصة مراكش، ندوة فيلا مراكش، عيد ميلاد فيلا مراكش، خلوة النخيل",
    },
    contact: {
      title: "اتصال وحجز مباشر — دار حسناء كولكشن مراكش",
      description:
        "احجز إقامتك مباشرة في فيلا إسماعيل أو فيلا حسناء. واتساب +212 7 18 11 54 19 · سيدي يحيى النخيل، مراكش. رد خلال 24 ساعة.",
      keywords:
        "حجز فيلا مراكش، اتصال دار حسناء، حجز فيلا النخيل، حجز مباشر فيلا مراكش",
    },
  },
};
